// import { Component, OnInit } from "@angular/core";
// import { LayoutService } from "libs/portal/src/layout/layout.service";
// import { GenericService } from "libs/portal/src/services/generic/generic.service";
// import { ToolsService } from "libs/portal/src/services/tools/tools.service";
// import { UserRightsService } from "libs/portal/src/services/user-rights/user-rights.service";
// import { Endpoints } from "src/config/endpoints";
// import { KADashboard } from "../../models/KADashboard";
// import { DataTile } from "../../models/DataTile";

import { Component, OnInit } from '@angular/core';
import { KADashboardModel, KAOnlinePerDateModel } from '../../models/KADashboard';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { DataTileModel } from '../../models/DataTile';
import { SegmentedTileModel } from '../../models/SegmentedTile';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { DeviceOnlineDateModel } from '../../components/data/components/data-device-over-time-chart/data-device-over-time-chart.component';

@Component({
  selector: 'app-keepalive',
  templateUrl: './keepalive.page.html',
  styleUrls: ['./keepalive.page.scss'],
})
export class KeepalivePageComponent implements OnInit {
  constructor(private http: GenericService, private endpoints: Endpoints, private auth: UserRightsService, private tools: ToolsService) {}

  //General
  dashboardData: KADashboardModel;
  lastUpdated: string;
  loading: boolean = true;

  //Tiles
  tileListRow1: DataTileModel[] = [];
  tileListRow2: DataTileModel[] = [];
  tileListRow3: SegmentedTileModel[] = [];
  tileListRow4: DataTileModel[] = [];

  //Graph
  devicesOverTimeData: DeviceOnlineDateModel[] | null = null;
  timeFrameMonths: number = 3;
  monthlyToggleValue: boolean = false;
  dailyToggleValue: boolean = true;

  ngOnInit(): void {
    this.getDashboardData();
  }

  getDashboardData(): void {
    const groupID = this.auth.GetGroupID();
    this.loading = true;
    this.http.GET(this.endpoints.GET_KEEPALIVE_DASHBOARD(groupID)).subscribe({
      next: (res: any) => {
        this.dashboardData = res.body;
        this.buildTileRow1();
        this.buildTileRow2();
        this.buildTileRow3();
        this.buildTileRow4();
        this.buildGraph('pastMonth');
        this.loading = false;
      },
    });
  }

  buildTileRow1(): void {
    this.tileListRow1 = [
      {
        title: 'Online',
        titleColor: 'light',
        value: `${this.dashboardData.HealthStats.Online}`,
        valueColor: 'light',
        tileColor: 'success',
      },
      {
        title: 'Offline',
        titleColor: 'light',
        value: `${this.dashboardData.HealthStats.Offline}`,
        valueColor: 'light',
        tileColor: 'danger',
      },
      {
        title: 'New devices this month',
        titleColor: 'light',
        value: `${this.dashboardData.HealthStats.New}`,
        valueColor: 'light',
        tileColor: 'primary',
      },
      {
        title: 'Devices at verified locations',
        titleColor: 'primary',
        value: `${this.dashboardData.HealthStats.VerifiedLocations}`,
        valueColor: 'primary',
        tileColor: 'light',
        subTitle: 'In this calendar month',
      },
      {
        title: 'Devices at unverified locations',
        titleColor: 'primary',
        value: `${this.dashboardData.HealthStats.UnverifiedLocations}`,
        valueColor: 'primary',
        tileColor: 'light',
        subTitle: 'In this calendar month',
      },
    ];
  }

  buildTileRow2(): void {
    this.tileListRow2 = [
      {
        title: 'Total ringfence breaches',
        titleColor: 'primary',
        value: `${this.dashboardData.HealthStats.RingfenceBreaches}`,
        valueColor: 'primary',
        tileColor: 'light',
        subTitle: 'In this calendar month',
      },
      {
        title: 'Unique ringfence breaches',
        titleColor: 'primary',
        value: `${this.dashboardData.HealthStats.DistinctRingfenceBreaches}`,
        valueColor: 'primary',
        tileColor: 'light',
        subTitle: 'In this calendar month',
      },
    ];
  }

  buildTileRow3(): void {
    this.tileListRow3.push({
      title: 'Keep Alive',
      values: [
        {
          value: this.dashboardData.HealthStats.Online,
          label: 'Online',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: this.dashboardData.HealthStats.Online12Hour,
          label: '< 12 hours ago',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: this.dashboardData.HealthStats.Online1Day,
          label: '< 1 day ago',
          valueColor: 'primary',
          labelColor: 'primary',
        },
        {
          value: this.dashboardData.HealthStats.Online1Week,
          label: '< 1 week ago',
          valueColor: 'primary',
          labelColor: 'primary',
        },
      ],
    });
  }

  buildTileRow4(): void {
    this.tileListRow4 = [
      {
        title: 'Online this month',
        titleColor: 'primary',
        value: `${this.dashboardData.HealthStats.OnlineMonth}`,
        valueColor: 'primary',
        tileColor: 'light',
        subTitle: '-',
        subTitleColor: 'light',
      },
      {
        title: 'Offline this month',
        titleColor: 'primary',
        value: `${this.dashboardData.HealthStats.OfflineMonth}`,
        valueColor: 'primary',
        tileColor: 'light',
        subTitle: '-',
        subTitleColor: 'light',
      },
    ];
  }

  buildGraph(timeFrame: 'currentMonth' | 'pastMonth' | 'month3' | 'month6' | 'month12'): void {
    this.devicesOverTimeData = null;
    let graphData: KAOnlinePerDateModel[];

    switch (timeFrame) {
      case 'currentMonth':
        graphData = this.dashboardData.OnlineCurrentMonth;
        break;
      case 'pastMonth':
        graphData = this.dashboardData.OnlinePastMonth;
        break;
      case 'month3':
        graphData = this.dashboardData.Online3Month;
        break;
      case 'month6':
        graphData = this.dashboardData.Online6Month;
        break;
      case 'month12':
        graphData = this.dashboardData.Online12Month;
        break;
    }

    setTimeout(() => {
      this.devicesOverTimeData = graphData.map((data) => {
        return {
          IntervalStart: data.Date,
          Online: data.Online,
        };
      });
      console.log(this.devicesOverTimeData);
    });
  }

  monthlyToggleChanged(): void {
    //Set timeout is required for some reason
    setTimeout(() => {
      this.monthlyToggleValue = !this.monthlyToggleValue;
      if (this.monthlyToggleValue) {
        if (this.timeFrameMonths == 3) {
          this.buildGraph('month3');
        } else if (this.timeFrameMonths == 6) {
          this.buildGraph('month6');
        } else {
          this.buildGraph('month12');
        }
        return;
      }
      if (this.dailyToggleValue) {
        this.buildGraph('pastMonth');
      } else {
        this.buildGraph('currentMonth');
      }
    });
  }

  dailyToggleChanged(): void {
    //Set timeout is required for some reason
    setTimeout(() => {
      this.dailyToggleValue = !this.dailyToggleValue;
      if (this.dailyToggleValue) {
        this.buildGraph('pastMonth');
      } else {
        this.buildGraph('currentMonth');
      }
    });
  }

  timeFrameChange(timeframe) {
    this.timeFrameMonths = +timeframe;
    if (timeframe == 3) {
      this.buildGraph('month3');
    } else if (timeframe == 6) {
      this.buildGraph('month6');
    } else if (timeframe == 12) {
      this.buildGraph('month12');
    }
  }
}
